import React, { useState } from 'react';
import { ILine as Line } from '../../../../global';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Card from '@material-ui/core/Card';
import Collapse from '@material-ui/core/Collapse';
import LineTotal from '../LineTotal';
import Units from '../Units';
import Box from '@material-ui/core/Box';
import Stages from './Stages';
import LineNameRow from './LineNameRow';
import MobileEditLineButton from './MobileEditLineButton';
import MobileLineDuration from './MobileLineDuration';

export interface MobileLineProps {
  line: Line;
  startExpand?: boolean;
  updateLineInfo?: (...args) => void;
  handleAddStage?: (...args) => void;
  handleStageUpdate?: (...args) => void;
  addOrDeleteError?: (...args) => void;
}

const useStyles = makeStyles((theme: any) => ({
  card: {
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  rowSpacing: { marginBottom: theme.spacing(1) },
  status: { marginLeft: 'auto' },
  expandButton: {
    padding: 0,
    marginLeft: theme.spacing(0.5),
    marginRight: -theme.spacing(0.5),
  },
}));

export default function MobileLine({
  line,
  startExpand = false,
  updateLineInfo = () => {},
  handleAddStage = () => {},
  handleStageUpdate = () => {},
  addOrDeleteError = () => {},
}: MobileLineProps) {
  const [expanded, setExpanded] = useState(startExpand);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const classes = useStyles();

  return (
    <>
      {line && (
        <Card variant="outlined" className={classes.card}>
          <Box display="flex" alignItems="center">
            <LineNameRow
              line={line}
              expanded={expanded}
              updateLineInfo={updateLineInfo}
              addOrDeleteError={addOrDeleteError}
              handleExpandClick={handleExpandClick}
            />
          </Box>
          <MobileLineDuration {...{ line }} />
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            className={expanded ? classes.rowSpacing : null}
          >
            <LineTotal line={line} />
            <Units
              line={line}
              setLineInfoDuringEdit={updateLineInfo}
              addOrDeleteError={addOrDeleteError}
            />
          </Box>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <Stages
              line={line}
              handleAddStage={handleAddStage}
              handleStageUpdate={handleStageUpdate}
              addOrDeleteError={addOrDeleteError}
            />

            {!line?.edit && <MobileEditLineButton line={line} />}
          </Collapse>
        </Card>
      )}
    </>
  );
}
